import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0bd5c5ba"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "loading"
};
const _hoisted_2 = { class: "image-element-container" };
const _hoisted_3 = ["src"];
const _hoisted_4 = ["href"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
    key: 2,
    class: "fade-overlay"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
    key: 2,
    class: "fade-overlay"
};
const _hoisted_9 = {
    key: 0,
    class: "slide-number"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedSpinner = _resolveComponent("FriedSpinner");
    const _component_ImageWithTransforms = _resolveComponent("ImageWithTransforms");
    const _component_ProsemirrorViewerInput = _resolveComponent("ProsemirrorViewerInput");
    const _component_EditorNodeWrapper = _resolveComponent("EditorNodeWrapper");
    return (_openBlock(), _createBlock(_component_EditorNodeWrapper, {
        class: _normalizeClass([
            'node-container',
            'image-container',
            _ctx.rowTypeClass,
            _ctx.blockWidthClass,
            _ctx.imageSize,
            _ctx.imageAlign,
            {
                'parent-first-child': _ctx.parentFirstChild,
                'parent-last-child': _ctx.parentLastChild,
            },
        ]),
        onObserveNodeVisibility: _cache[4] || (_cache[4] = ($event) => (_ctx.$emit('observe-node-visibility', Object.assign(Object.assign({}, $event), { nodeId: _ctx.node.id }))))
    }, {
        default: _withCtx(() => [
            _createElementVNode("div", {
                ref: "imageContent",
                class: _normalizeClass([
                    'image-content',
                    {
                        'no-src-url': !_ctx.node.srcUrl,
                    },
                ])
            }, [
                (!_ctx.isPdfViewer && _ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", {
                            style: _normalizeStyle(_ctx.imageLoaderContainerStyle)
                        }, [
                            _createVNode(_component_FriedSpinner, {
                                class: "button-loader-icon",
                                size: 40
                            })
                        ], 4)
                    ]))
                    : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_2, [
                    (_ctx.node.externalId)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "unsplash-beacon",
                            src: _ctx.unsplashBeaconSrcUrl
                        }, null, 8, _hoisted_3))
                        : _createCommentVNode("", true),
                    (_ctx.node.linkUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: _ctx.node.linkUrl,
                            target: "_blank"
                        }, [
                            (_ctx.rowType === _ctx.RowType.Columns)
                                ? (_openBlock(), _createBlock(_component_ImageWithTransforms, {
                                    key: 0,
                                    class: "image",
                                    image: _ctx.node,
                                    "page-width": _ctx.pageWidth,
                                    "is-block-toggled": _ctx.isBlockToggled,
                                    "block-width-class": _ctx.blockWidthClass,
                                    onImageLoaded: _ctx.handleImageLoaded,
                                    onImageLoadError: _ctx.handleLoadError
                                }, null, 8, ["image", "page-width", "is-block-toggled", "block-width-class", "onImageLoaded", "onImageLoadError"]))
                                : (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    class: "image",
                                    src: _ctx.node.srcUrl,
                                    alt: "",
                                    onLoad: _cache[0] || (_cache[0] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleImageLoaded && _ctx.handleImageLoaded(...args))),
                                    onError: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleLoadError && _ctx.handleLoadError(...args)))
                                }, null, 40, _hoisted_5)),
                            (_ctx.isHeadingSet)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                                : _createCommentVNode("", true)
                        ], 8, _hoisted_4))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (_ctx.rowType === _ctx.RowType.Columns)
                                ? (_openBlock(), _createBlock(_component_ImageWithTransforms, {
                                    key: 0,
                                    class: "image",
                                    image: _ctx.node,
                                    "page-width": _ctx.pageWidth,
                                    "is-block-toggled": _ctx.isBlockToggled,
                                    "block-width-class": _ctx.blockWidthClass,
                                    onImageLoaded: _ctx.handleImageLoaded,
                                    onImageLoadError: _ctx.handleLoadError
                                }, null, 8, ["image", "page-width", "is-block-toggled", "block-width-class", "onImageLoaded", "onImageLoadError"]))
                                : (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    class: "image",
                                    src: _ctx.node.srcUrl,
                                    alt: "",
                                    onLoad: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleImageLoaded && _ctx.handleImageLoaded(...args))),
                                    onError: _cache[3] || (_cache[3] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleLoadError && _ctx.handleLoadError(...args)))
                                }, null, 40, _hoisted_7)),
                            (_ctx.isHeadingSet)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                                : _createCommentVNode("", true)
                        ], 64)),
                    (_ctx.isHeadingSet)
                        ? (_openBlock(), _createBlock(_component_ProsemirrorViewerInput, {
                            key: 3,
                            ref: "headingInput",
                            style: _normalizeStyle(_ctx.fontSize),
                            class: "image-heading",
                            content: _ctx.node.heading,
                            onLoaded: _ctx.handleTextLoaded
                        }, null, 8, ["style", "content", "onLoaded"]))
                        : _createCommentVNode("", true)
                ], 512), [
                    [_vShow, _ctx.isPdfViewer || _ctx.isLoaded]
                ]),
                (_ctx.isCaptionSet)
                    ? (_openBlock(), _createBlock(_component_ProsemirrorViewerInput, {
                        key: 1,
                        class: "image-caption",
                        content: _ctx.node.caption
                    }, null, 8, ["content"]))
                    : _createCommentVNode("", true)
            ], 2),
            (_ctx.isGridView && _ctx.slideNumber)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.slideNumber), 1))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }, 8, ["class"]));
}
